import {useMessage} from '@coolcolduk/ui-mui';
import {Button, Dialog, DialogContent, DialogTitle, Grid, Typography} from '@mui/material';
import {QueueJob, QueueJobStatus} from '../../__generated__/resolvers-types';
import {useResumeQueueJob} from '../../hook/useResumeQueueJob';
import JobListItemLogItem from './JobListItemLogItem';

export interface JobListItemLogProps {
  open: boolean;
  onClose: () => void;
  job: QueueJob;
}

export default function JobListItemLog({open, onClose, job}: JobListItemLogProps) {
  const resumeJob = useResumeQueueJob();
  const data =
    job.etsyBulkCreateCsv?.items ||
    job.etsyBulkCreateGdriveFile?.items ||
    job.etsyBulkCreateGdriveFolder?.items ||
    job.etsyBulkUpdateCsv?.items ||
    job.imageToImageGeneration?.items ||
    [];

  const dataWithErrors = data.filter((item) => item.error);
  const {showMessage} = useMessage();

  const handleResume = async () => {
    try {
      const success = await resumeJob(job.id);
      if (success) {
        onClose();
        showMessage('Job resumed', undefined, 'info');
      }
    } catch (_e) {
      showMessage('Resume job failed', undefined, 'error');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography>Job Log: {job.id}</Typography>
          {job.status === QueueJobStatus.QUEUE && (
            <Button variant="contained" color="primary" onClick={handleResume}>
              Resume Job
            </Button>
          )}
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          {dataWithErrors.length > 0 &&
            dataWithErrors.map((item, ind) => (
              <JobListItemLogItem key={`${item.id}-${'name' in item ? item.name : ind}`} item={item} />
            ))}

          {dataWithErrors.length === 0 && (
            <Grid
              size={{xs: 12}}
              sx={{
                bgcolor: 'background.paper',
                p: 2,
                borderRadius: 1,
                textAlign: 'center',
              }}
            >
              <Typography variant="body2" color="text.secondary">
                No errors
              </Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
